/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, Dimensions, TouchableOpacity } from 'react-native';
import { isNative } from '@global/screens';
import Colors from '@/global/colors';
import { parseDate } from '@/global/helpers';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const photoSize = 25;
const userBadge = 5;

const dimension = Dimensions.get('screen');

const ActivityItem = ({ current, data, userColors, isToday, onPress }) => {
  const getUserColors = (item) => {
    const key = item && item.user && item.user.id ? item.user.id : '-';
    return userColors[key];
  };
  const goToDetail = (item) => {
    if (item && item._id) {
      onPress(item._id);
    }
  };
  return (
    <View
      style={{ width: '100%', flexDirection: 'row', alignItems: 'flex-start' }}>
      <View
        style={{
          width: 55,
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: 10,
          paddingBottom: data && data.length ? 0 : 10,
        }}>
        <SociollaText
          style={{
            fontSize: 12,
            color: isToday ? Colors.blue0 : Colors.black,
          }}>
          {parseDate(current, 'E')}
        </SociollaText>
        <SociollaText
          type="medium"
          style={{
            fontSize: 20,
            color: isToday ? Colors.blue0 : Colors.black,
          }}>
          {parseDate(current, 'dd')}
        </SociollaText>
      </View>
      <View
        style={{
          width: !isNative ? 'calc(100% - 55px)' : dimension.width - 55,
        }}>
        <View style={{ width: '100%' }}>
          {data && data.length ? (
            data
              .sort((a, b) => new Date(a.visited_at) - new Date(b.visited_at))
              .map((item, idx) => (
                <TouchableOpacity
                  onPress={() => goToDetail(item)}
                  activeOpacity={0.6}
                  style={styles.rightItem}
                  key={idx}>
                  <SociollaText
                    style={{ color: Colors.grey1, marginBottom: 3 }}>
                    {`${
                      item?.start_time && item?.end_time
                        ? `${item?.start_time} - ${item?.end_time}`
                        : `-`
                    }`}
                  </SociollaText>
                  <SociollaText style={{ marginBottom: 3 }}>
                    {item.title}
                  </SociollaText>
                  <View
                    style={{
                      width: '100%',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}>
                    <View style={{ position: 'relative' }}>
                      <View
                        style={{
                          width: photoSize,
                          height: photoSize,
                          borderRadius: photoSize,
                          overflow: 'hidden',
                        }}>
                        <Image
                          style={{ width: photoSize, height: photoSize }}
                          width={photoSize}
                          height={photoSize}
                          isPhoto
                          source={require('@/assets/img/default/user-default.png')}
                        />
                      </View>
                      <View
                        style={{
                          width: userBadge,
                          height: userBadge,
                          borderRadius: 10,
                          overflow: 'hidden',
                          position: 'absolute',
                          bottom: '5%',
                          right: '5%',
                          zIndex: 1,
                          elevation: 1,
                          backgroundColor: getUserColors(item),
                        }}></View>
                    </View>
                    <SociollaText style={{ fontSize: 12, marginLeft: 5 }}>
                      {item.user && item.user.name ? item.user.name : '-'}
                    </SociollaText>
                  </View>
                </TouchableOpacity>
              ))
          ) : (
            <View
              style={[
                styles.rightItem,
                {
                  minHeight: 58,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                },
              ]}>
              <SociollaText>No planned activities for this day</SociollaText>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  rightItem: {
    width: '100%',
    paddingVertical: 10,
    paddingRight: 15,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
});

export default ActivityItem;
